import { useEffect } from "react";

const TENANT_PRIMARY_VAR = "--tenant-primary";
const BRANDED_CLASS = "tenant-branded";

/**
 * Applies the tenant's brand primary color to the whole document: sets
 * `--tenant-primary` inline on `<html>` and adds the `tenant-branded` class,
 * which re-points `--primary` / `--ring` and color-mixes the derived tones
 * (see `styles/globals.css`). No-op for missing or invalid CSS color values,
 * so a malformed DB value degrades to the stock teal instead of breaking the
 * UI. Cleans up on unmount (e.g. sign-out unmounts the authenticated layout).
 */
export const useTenantPrimaryColor = (
	primaryColor: string | null | undefined,
): void => {
	useEffect(() => {
		if (!primaryColor || !CSS.supports("color", primaryColor)) {
			return;
		}
		const root = document.documentElement;
		root.style.setProperty(TENANT_PRIMARY_VAR, primaryColor);
		root.classList.add(BRANDED_CLASS);
		return () => {
			root.style.removeProperty(TENANT_PRIMARY_VAR);
			root.classList.remove(BRANDED_CLASS);
		};
	}, [primaryColor]);
};
